import React, { useEffect, useState } from 'react'
import { Select, Form, Input } from 'antd'
import { Button, Col, Row, Table, Modal } from 'antd'
import apiRequest from '../hooks/ApiRequest'
import { useParams, useHistory } from 'react-router-dom/cjs/react-router-dom.min'
import Layouts from './Layouts'
import { toast } from 'react-toastify'
const AuthorisePolicy = ({ form }) => {
  const { getFieldDecorator } = form
  const [policydetail, setPolicyDetail] = useState([])
  const [productdetail, setproductdetail] = useState(null)
  const [loading, setLoading] = useState(false)
  const [data, setData] = useState([])
  const [insurerOptions, setInsurerOptions] = useState([])
  const [selectedInsurer, setSelectedInsurer] = useState(null)
  const [reinsuredAmount, setReinsuredAmount] = useState('')
  const [sumInsured, setsumInsured] = useState(0)
  const [totalSumInsured, setTotalSumInsured] = useState(0)

  const [showModal, setShowModal] = useState(false) // Modal visibility state

  const [showReinsuranceSection, setShowReinsuranceSection] = useState(false)

  const { policyId } = useParams()
  const history = useHistory()
  const user = JSON.parse(localStorage.getItem('user'))
  console.log('Logged in user:', user) // Add this line
  const userRole = user
  const loggedInUserInsurerId = user?.UserId || user?.nameid
  console.log('loggedInUserInsurerId:', loggedInUserInsurerId)
  console.log(
    'Filtered options:',
    insurerOptions.filter(
      option => option.value.toString() !== loggedInUserInsurerId.toString(),
    ),
  )

  const columns = [
    {
      key: 'policy_cover',
      title: 'Policy Cover ',
      dataIndex: 'policy_cover',
    },
    {
      key: 'riskitem',
      title: 'Risk Item ',
      dataIndex: 'riskitemname',
    },
    {
      key: 'address',
      title: 'Risk Address',
      dataIndex: 'address',
    },
    {
      key: 'suminsured',
      title: 'Sum Insured',
      dataIndex: 'suminsured',
      render: suminsured => {
        return parseFloat(suminsured).toFixed(2)
      },
    },
    {
      key: 'Proratapremium',
      title: 'Premium',
      dataIndex: 'annualpremium',
      render: annualpremium => {
        return parseFloat(annualpremium).toFixed(2)
      },
    },
  ]
  useEffect(
    () => {
      if (policyId) {
        fetchPolicyDetail(policyId)
        fetchInsurers()
      }
    },
    [policyId],
    [showReinsuranceSection],
  )

  const fetchInsurers = async () => {
    try {
      const response = await apiRequest(
        `${process.env.REACT_APP_BASE_URL_AUTH}/api/Auth/UsersForDropdown/insurer`,
        'GET',
      )
      const dropdownOptions = response?.data?.map(user => ({
        label: user.name,
        value: user.id,
      }))
      setInsurerOptions(dropdownOptions)
    } catch (error) {
      console.error('Failed to load insurers', error)
    }
  }

  const submitroute = () => {
    history.push('/policies')
  }
  const fetchPolicyDetail = async policyId => {
    try {
      const response = await apiRequest(
        process.env.REACT_APP_BASE_URL + `/Policy/GetPolicybyid/${policyId}`,
        'GET',
      )
      setPolicyDetail(response.data || [])
      setData(response.data?.policydetail.riskitemdetails)
      let productId = response.data?.policydetail.productid
      let insurerId = response.data?.policydetail.insurerId
      let sumInsuredValue = parseFloat(
        response.data?.policydetail?.totalSumInsured || 0,
      )
      const insurerProductRes = await apiRequest(
        process.env.REACT_APP_BASE_URL_INSURER +
        `/api/Insurer/GetInsurerProductByInsurerIdProductId?productId=${productId}&insurerId=${insurerId}`,
        'GET',
      )

      setproductdetail(insurerProductRes?.data?.insurerProduct)

      console.log('showReinsuranceSection', showReinsuranceSection)
    } catch (error) {
      console.error('Error fetching assigned users', error)
    }
  }


  const onAuthorizeClick = () => {
    debugger;
    const totalSumInsured = policydetail?.policydetail?.riskitemdetails
      ?.reduce((acc, item) => acc + (item.suminsured || 0), 0) ?? 0;
    if (totalSumInsured > productdetail?.maxLimit) {
      setShowModal(true)
      return false;
    } else {
      handleSubmit()
    }
  }

  const handleSubmit = async (reinsurerIdParam) => {
    form.validateFields(async (err, values) => {
      if (err) return;
      setLoading(true);
      debugger;
      try {
        let reinsurerIdToUse = reinsurerIdParam || selectedInsurer;
        const totalSumInsured = policydetail?.policydetail?.riskitemdetails
          ?.reduce((acc, item) => acc + (item.suminsured || 0), 0) ?? 0;
        if (totalSumInsured > productdetail?.maxLimit) {
          if (!reinsurerIdToUse) {
            toast.error('Please select a reinsurer');
            setLoading(false);
            return;
          }

          const reinsurancePayload = {
            policyId,
            InsurerId: reinsurerIdToUse,
            ReinsuredAmount: parseFloat(totalSumInsured - productdetail?.maxLimit),
            SumInsured: parseFloat(totalSumInsured),
          };

          const reinsuranceResponse = await apiRequest(
            process.env.REACT_APP_BASE_URL +
            `/Policy/AddReinsuranceRecord/AddReinsuranceRecord`,
            'POST',
            reinsurancePayload,
          );

          if (!reinsuranceResponse?.success) {
            toast.error('Failed to save reinsurance info');
            setLoading(false);
            return;
          }
        }


        const reinsurerName = insurerOptions.find(
          (i) => i.value === reinsurerIdToUse,
        )?.label;

        if (reinsurerIdToUse) {
          const updateReinsurerPayload = {
            policyId,
            reinsurerId: reinsurerIdToUse,
            reinsurerName: reinsurerName || null,
            reinsuranceLimit: productdetail?.maxLimit || 0,
          };

          const updateReinsurerResponse = await apiRequest(
            process.env.REACT_APP_BASE_URL + `/Policy/UpdatePolicyReinsurer/UpdatePolicyReinsurer`,
            'POST',
            updateReinsurerPayload,
          );

          if (!updateReinsurerResponse?.success) {
            toast.error('Failed to update reinsurer info on policy');
            setLoading(false);
            return;
          }
        }


        const statusUpdatePayload = {
          id: parseInt(policyId),
          status: 7, // Active Status
          ReinsurerId: reinsurerIdToUse || null,
          ReinsurerName: reinsurerName || null,
        };

        const AuthoriseByInsrurer = await apiRequest(
          `${process.env.REACT_APP_BASE_URL_MICROSERVICE}/Policy/StatusUpdate/status-update`,
          'POST',
          statusUpdatePayload,
        );

        if (AuthoriseByInsrurer?.success) {
          toast.success('Policy has been authorized');
          history.push('/policies');
        } else {
          toast.error(AuthoriseByInsrurer?.message || 'Failed to authorize policy');
        }
      } catch (error) {
        toast.error('Submission error');
      } finally {
        setLoading(false);
      }
    });
  };




  return (
    <>
      <Layouts title="Email Templates" classname="dashboard">
        <div className="body-height">
          <div className="bg-white">
            <div className="dash-bg-white">
              <Row gutter={[16, 16]}>
                <Col xs={24} sm={24} md={24} lg={12}>
                  <div className="section-top-heading">
                    <h3
                      style={{
                        color: '#0C1362',
                        fontWeight: '600',
                        fontSize: '25px',
                      }}>
                      Authorise Policy
                    </h3>
                  </div>
                </Col>
                <div className="btn-group-success">
                  <Button
                    className="btn-success"
                    size="default"
                    value={'submit'}
                    onClick={submitroute}>
                    Go Back
                  </Button>
                </div>
              </Row>
            </div>
            <div className="dash-bg-white">
              <div className="container-box" style={{ marginTop: '15px' }}>
                <div
                  id="divToPrint"
                  className="white-box-bg"
                  style={{ padding: '30px 15px 50px' }}>
                  <div>
                    <h4
                      style={{
                        padding: '5px 2px',
                        fontSize: '14px',
                        fontWeight: '800',
                        margin: '0',
                        textTransform: 'capitalize',
                      }}>
                      Customer Details
                    </h4>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                      <div style={{ width: '50%' }}>
                        <ul
                          style={{
                            padding: '5px 20px 20px 0',
                            fontSize: '14px',
                            color: '#000',
                            fontWeight: '500',
                            margin: '0',
                            listStyle: 'none',
                          }}>
                          <li>Name : </li>
                          <li>Mobile:</li>
                          <li>Address:</li>
                          <li>Age:</li>
                          <li>National Id:</li>
                        </ul>
                      </div>
                      <div style={{ width: '50%' }}>
                        <ul
                          style={{
                            padding: '5px 20px 20px 0',
                            fontSize: '14px',
                            color: '#000',
                            fontWeight: '500',
                            margin: '0',
                            listStyle: 'none',
                          }}>
                          <li>
                            {' '}
                            {policydetail?.customerdetail?.clientfirstname ||
                              '-'}{' '}
                            {policydetail?.customerdetail?.clientsurname}
                          </li>
                          <li>
                            {policydetail?.customerdetail
                              ?.clientcontactnumber || '-'}
                          </li>
                          <li>
                            {policydetail?.customerdetail?.clientaddress1 ||
                              '-'}
                          </li>
                          <li>
                            {policydetail?.customerdetail?.clientage || '-'}
                          </li>
                          <li>
                            {policydetail?.customerdetail?.nationalid || '-'}
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <h4
                    style={{
                      padding: '5px 2px',
                      fontSize: '14px',
                      fontWeight: '800',
                      margin: '0',
                      textTransform: 'capitalize',
                    }}>
                    Policy Details
                  </h4>
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <div style={{ width: '50%' }}>
                      <ul
                        style={{
                          padding: '5px 20px 20px 0',
                          fontSize: '14px',
                          color: '#000',
                          fontWeight: '500',
                          margin: '0',
                          listStyle: 'none',
                        }}>
                        <li>Policy Number : </li>
                        <li>Period of Insurance:</li>
                        <li>Transaction Date:</li>
                        <li>Currency:</li>
                      </ul>
                    </div>
                    <div style={{ width: '50%' }}>
                      <ul
                        style={{
                          padding: '5px 20px 20px 0',
                          fontSize: '14px',
                          color: '#000',
                          fontWeight: '500',
                          margin: '0',
                          listStyle: 'none',
                        }}>
                        <li>{policydetail?.policydetail?.policynumber}</li>
                        <li>
                          {policydetail?.policydetail?.policystartdate}
                          <b> To </b>
                          {policydetail?.policydetail?.policyexpirytdate}
                        </li>
                        <li>{policydetail?.policydetail?.transactionDate}</li>
                        <li>{policydetail?.policydetail?.currency}</li>
                      </ul>
                    </div>
                  </div>
                  <div>
                    <h4
                      style={{
                        padding: '5px 2px',
                        fontSize: '14px',
                        fontWeight: '800',
                        margin: '0',
                        textTransform: 'capitalize',
                      }}>
                      Product Details
                    </h4>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                      <div style={{ width: '50%' }}>
                        <ul
                          style={{
                            padding: '0 20px 20px 2px',
                            color: '#000',
                            fontSize: '14px',
                            fontWeight: '700',
                            margin: '0',
                            listStyle: 'none',
                          }}>
                          <li>Product :</li>
                        </ul>
                      </div>
                      <div style={{ width: '50%' }}>
                        <ul
                          style={{
                            padding: '0 20px 20px 2px',
                            color: '#000',
                            fontSize: '14px',
                            fontWeight: '700',
                            margin: '0',
                            listStyle: 'none',
                          }}>
                          <li>{policydetail?.policydetail?.productname}</li>
                        </ul>
                      </div>
                    </div>
                    <div>
                      <h4
                        style={{
                          padding: '5px 2px',
                          fontSize: '14px',
                          color: '#000',
                          fontWeight: '800',
                          margin: '0',
                          textTransform: 'capitalize',
                        }}>
                        Policy Cover Details
                      </h4>
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        <div style={{ width: '50%' }}>
                          <ul
                            style={{
                              padding: '0 20px 20px 2px',
                              color: '#000',
                              fontSize: '14px',
                              fontWeight: '500',
                              margin: '0',
                              listStyle: 'none',
                            }}>
                            <li>Policy Cover:</li>
                          </ul>
                        </div>
                        <div style={{ width: '50%' }}>
                          <ul
                            style={{
                              padding: '0 20px 20px 2px',
                              color: '#000',
                              fontSize: '14px',
                              fontWeight: '500',
                              margin: '0',
                              listStyle: 'none',
                            }}>
                            <li>
                              {policydetail?.policydetail?.policyriskcover}
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                    <div className="dataSource-grid">
                      <Table
                        rowKey={record => record.policyriskitemid}
                        columns={columns}
                        dataSource={data}
                        pagination={false}
                      />
                    </div>

                    {/* {policydetail?.policydetail?.totalSumInsured > productdetail?.maxLimit && (
                      <div style={{ marginTop: '20px', marginBottom: '20px' }}>
                        <h4 style={{ fontWeight: '600' }}>Reinsurance Details</h4>
                        <div style={{ display: 'flex', gap: '20px', alignItems: 'center' }}>
                          <div style={{ flex: 1 }}>
                            <label style={{ fontSize: '14px' }}>Insurer:</label>
                            <Select
                              style={{ width: '100%' }}
                              placeholder="Select Insurer"
                              value={selectedInsurer}
                             defaultValue="Select Insurer"
                              onChange={value => setSelectedInsurer(value)}
                            >
                              {insurerOptions.filter(option => option.value.toString() !== loggedInUserInsurerId.toString()).map(option => (
                                <Select.Option key={option.value} value={option.value}>
                                  {option.label}
                                </Select.Option>
                              ))}
                            </Select>
                          </div>
                        </div>
                      </div>
                    )} */}

                    <Button
                      onClick={onAuthorizeClick}
                      type="primary"
                      loading={loading}>
                      Authorise Policy
                    </Button>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>


        {/* Modal for selecting reinsurer */}
        <Modal
          visible={showModal}
          title="Select Reinsurer"
          onCancel={() => setShowModal(false)}
          onOk={() => {
            if (!selectedInsurer) {
              toast.error('Please select a reinsurer')
              return
            }
            setShowModal(false)
            handleSubmit(selectedInsurer)
          }}
          okText="Authorize Policy"
          cancelText="Cancel"
          confirmLoading={loading}
        >
          <Form.Item label="Reinsurer" required>
            <Select
              placeholder="Select a reinsurer"
              value={selectedInsurer}
              onChange={(value) => setSelectedInsurer(value)}
            >
              {insurerOptions
                .filter(
                  (option) =>
                    option.value.toString() !== loggedInUserInsurerId.toString(),
                )
                .map((option) => (
                  <Select.Option key={option.value} value={option.value}>
                    {option.label}
                  </Select.Option>
                ))}
            </Select>
          </Form.Item>
        </Modal>

      </Layouts>
    </>
  )
}

// export default AuthorisePolicy

export default Form.create({ name: 'AuthorisePolicy' })(AuthorisePolicy);
